package com.zaurh.resume

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.VerticalDivider
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.lifecycle.viewmodel.compose.viewModel
import com.zaurh.resume.ui.theme.ResumeTheme
import kotlinx.browser.window
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource
import resume.app.shared.generated.resources.Res
import resume.app.shared.generated.resources.ic_github
import resume.app.shared.generated.resources.ic_mail
import resume.app.shared.generated.resources.ic_moon
import resume.app.shared.generated.resources.ic_phone
import resume.app.shared.generated.resources.ic_sun
import resume.app.shared.generated.resources.image_zaur

@Composable
@Preview
fun App() {
    var darkTheme by remember { mutableStateOf(false) }

    ResumeTheme(darkTheme = darkTheme) {
        BoxWithConstraints(modifier = Modifier.fillMaxSize()) {
            val maxWidth = maxWidth

            val isCompact = maxWidth < 600.dp

            Column(
                modifier = Modifier.fillMaxSize().background(MaterialTheme.colorScheme.surface)
                    .verticalScroll(rememberScrollState()),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Spacer(modifier = Modifier.height(8.dp))
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(bottom = 12.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Row(
                        modifier = Modifier.weight(1f),
                        horizontalArrangement = Arrangement.Center
                    ) {
                        Row(
                            horizontalArrangement = Arrangement.spacedBy(36.dp)
                        ) {
                            Button(
                                modifier = Modifier.pointerHoverIcon(
                                    PointerIcon.Hand
                                ),
                                colors = ButtonDefaults.buttonColors(
                                    containerColor = Color.DarkGray,
                                ), onClick = {
                                    downloadFile()
                                }) {
                                Text(
                                    text = "Download CV",
                                    fontWeight = FontWeight.Bold,
                                    color = Color.White
                                )
                            }
                        }
                    }

                    val darkModeSize = (maxWidth * 0.05f).coerceIn(12.dp, 36.dp)

                    Icon(
                        painter = painterResource(if (darkTheme) Res.drawable.ic_sun else Res.drawable.ic_moon),
                        contentDescription = null,
                        modifier = Modifier.padding(end = 24.dp).size(darkModeSize).clickable {
                            darkTheme = !darkTheme
                        },
                        tint = if (darkTheme) Color.White else MaterialTheme.colorScheme.primary
                    )
                }

                HorizontalDivider(
                    thickness = 1.dp,
                    color = MaterialTheme.colorScheme.outline.copy(alpha = 0.2f)
                )
                Spacer(modifier = Modifier.height(4.dp))

                Column(
                    modifier = Modifier.fillMaxSize().padding(24.dp),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(10.dp)
                    ) {
                        Spacer(modifier = Modifier.width(12.dp))
                        Image(
                            painter = painterResource(Res.drawable.image_zaur),
                            contentDescription = null,
                            modifier = Modifier.size(120.dp).clip(CircleShape),
                            contentScale = ContentScale.Crop
                        )
                        Column {
                            Text(
                                text = "ZAUR HASANOV",
                                fontWeight = FontWeight.Bold,
                                fontSize = if (isCompact) 24.sp else 32.sp,
                                color = MaterialTheme.colorScheme.primary
                            )
                            Text(
                                text = "Android Developer",
                                fontSize = if (isCompact) 16.sp else 24.sp,
                                color = MaterialTheme.colorScheme.primary
                            )
                            Spacer(modifier = Modifier.height(24.dp))

                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(
                                    painter = painterResource(Res.drawable.ic_phone),
                                    contentDescription = null,
                                    modifier = Modifier.size(if (isCompact) 18.dp else 20.dp),
                                    tint = MaterialTheme.colorScheme.primary
                                )
                                Spacer(modifier = Modifier.width(8.dp))
                                Text(
                                    text = "+48514348813",
                                    fontSize = if (isCompact) 14.sp else 16.sp,
                                    color = MaterialTheme.colorScheme.primary
                                )
                                if (!isCompact) {
                                    Spacer(modifier = Modifier.width(12.dp))
                                    Icon(
                                        painter = painterResource(Res.drawable.ic_mail),
                                        contentDescription = null,
                                        modifier = Modifier.size(if (isCompact) 18.dp else 20.dp),
                                        tint = MaterialTheme.colorScheme.primary
                                    )
                                    Spacer(modifier = Modifier.width(8.dp))
                                    Text(
                                        text = "zaurway@gmail.com",
                                        modifier = Modifier.pointerHoverIcon(PointerIcon.Hand)
                                            .clickable {
                                                window.open("mailto:zaurway@gmail.com", "_blank")
                                            },
                                        fontSize = if (isCompact) 14.sp else 16.sp,
                                        color = MaterialTheme.colorScheme.primary
                                    )
                                }
                            }
                            if (isCompact) {
                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    Icon(
                                        painter = painterResource(Res.drawable.ic_mail),
                                        contentDescription = null,
                                        modifier = Modifier.size(if (isCompact) 18.dp else 20.dp),
                                        tint = MaterialTheme.colorScheme.primary
                                    )
                                    Spacer(modifier = Modifier.width(8.dp))
                                    Text(
                                        text = "zaurway@gmail.com",
                                        modifier = Modifier.pointerHoverIcon(PointerIcon.Hand)
                                            .clickable {
                                                window.open("mailto:zaurway@gmail.com", "_blank")
                                            },
                                        fontSize = if (isCompact) 14.sp else 16.sp,
                                        color = MaterialTheme.colorScheme.primary
                                    )
                                }
                            }
                            if (!isCompact) {
                                Spacer(modifier = Modifier.height(12.dp))
                            }
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(
                                    painter = painterResource(Res.drawable.ic_github),
                                    contentDescription = null,
                                    modifier = Modifier.size(if (isCompact) 18.dp else 20.dp),
                                    tint = MaterialTheme.colorScheme.primary
                                )
                                Spacer(modifier = Modifier.width(8.dp))
                                Text(
                                    text = "https://github.com/zaurh",
                                    modifier = Modifier.pointerHoverIcon(PointerIcon.Hand)
                                        .clickable {
                                            window.open("https://github.com/zaurh", "_blank")
                                        }, fontSize = if (isCompact) 14.sp else 16.sp,
                                    color = MaterialTheme.colorScheme.primary
                                )
                            }
                        }
                    }
                    Spacer(modifier = Modifier.height(24.dp))
                    HorizontalDivider(modifier = Modifier.fillMaxWidth(fraction = 0.7f))
                    Spacer(modifier = Modifier.height(24.dp))
                    Row(
                        modifier = Modifier.fillMaxSize()
                    ) {
                        Column(modifier = Modifier.weight(1f)) {
                            Text(
                                text = "EDUCATION",
                                fontWeight = FontWeight.Bold,
                                fontSize = if (isCompact) 16.sp else 20.sp,
                                color = MaterialTheme.colorScheme.primary
                            )
                            Spacer(modifier = Modifier.height(24.dp))
                            Text(
                                text = "English Teaching\nBaku Slavic University",
                                fontWeight = FontWeight.Bold,
                                fontSize = if (isCompact) 12.sp else 16.sp,
                                color = MaterialTheme.colorScheme.primary
                            )
                            Text(
                                text = "2015 - 2019",
                                fontSize = if (isCompact) 14.sp else 16.sp,
                                color = MaterialTheme.colorScheme.primary
                            )
                            Spacer(modifier = Modifier.height(12.dp))
                            Text(
                                text = "Data Science\nWSB Akademia",
                                fontWeight = FontWeight.Bold,
                                fontSize = if (isCompact) 12.sp else 16.sp,
                                color = MaterialTheme.colorScheme.primary
                            )
                            Text(
                                text = "2020 - 2024",
                                fontSize = if (isCompact) 14.sp else 16.sp,
                                color = MaterialTheme.colorScheme.primary
                            )

                            Spacer(modifier = Modifier.height(24.dp))
                            Text(
                                text = "EXPERTISE",
                                fontWeight = FontWeight.Bold,
                                fontSize = if (isCompact) 16.sp else 20.sp,
                                color = MaterialTheme.colorScheme.primary
                            )
                            Spacer(modifier = Modifier.height(24.dp))
                            Text(
                                text = "Problem Solving\n" +
                                        "Critical Thinking\n" +
                                        "Team Collaboration\n" +
                                        "Communication Skills\n" +
                                        "Adaptability\n" +
                                        "Time Management\n" +
                                        "Attention to Detail\n" +
                                        "Continuous Learning\n" +
                                        "Responsibility\n" +
                                        "Self-Motivation\n" +
                                        "Creativity",
                                fontSize = if (isCompact) 14.sp else 16.sp,
                                color = MaterialTheme.colorScheme.primary
                            )
                            Spacer(modifier = Modifier.height(24.dp))
                            Text(
                                text = "LANGUAGE",
                                fontWeight = FontWeight.Bold,
                                fontSize = if (isCompact) 16.sp else 20.sp,
                                color = MaterialTheme.colorScheme.primary
                            )
                            Spacer(modifier = Modifier.height(24.dp))
                            Text(
                                text = "Azerbaijani ${if (!isCompact) "(Native)" else ""}\n" +
                                        "Turkish ${if (!isCompact) "(Native)" else ""}\n" +
                                        "Russian ${if (!isCompact) "(Intermediate)" else ""}\n" +
                                        "Polish ${if (!isCompact) "(Advanced)" else ""}\n" +
                                        "English ${if (!isCompact) "(Advanced)" else ""}\n",
                                fontSize = if (isCompact) 14.sp else 16.sp,
                                color = MaterialTheme.colorScheme.primary
                            )
                        }
                        VerticalDivider(
                            modifier = Modifier.height(800.dp).padding(horizontal = 24.dp)
                        )
                        Column(modifier = Modifier.weight(2f)) {
                            Text(
                                text = "PROFILE",
                                fontWeight = FontWeight.Bold,
                                fontSize = if (isCompact) 16.sp else 20.sp,
                                color = MaterialTheme.colorScheme.primary
                            )
                            Spacer(modifier = Modifier.height(24.dp))
                            Text(
                                text = "I'm an energetic and motivated Android Developer who's always eager to learn something new, take on extra responsibilities, and keep growing professionally, I enjoy working on challenging projects, building clean and user-friendly apps, and constantly improving my skills.",
                                fontSize = if (isCompact) 14.sp else 16.sp,
                                color = MaterialTheme.colorScheme.primary
                            )
                            Spacer(modifier = Modifier.height(24.dp))
                            Text(
                                text = "WORK EXPERIENCE",
                                fontWeight = FontWeight.Bold,
                                fontSize = if (isCompact) 16.sp else 20.sp,
                                color = MaterialTheme.colorScheme.primary
                            )
                            Spacer(modifier = Modifier.height(24.dp))
                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.SpaceBetween
                            ) {
                                Text(
                                    text = "Android Developer",
                                    fontWeight = FontWeight.Bold,
                                    fontSize = 16.sp,
                                    color = MaterialTheme.colorScheme.primary
                                )
                                if (!isCompact) {
                                    Text(
                                        text = "15/05/2025 - Present",
                                        fontSize = 16.sp,
                                        fontWeight = FontWeight.Bold,
                                        color = MaterialTheme.colorScheme.primary
                                    )
                                }
                            }
                            if (isCompact) {
                                Text(
                                    text = "15/05/2025 - Present",
                                    fontSize = if (isCompact) 12.sp else 16.sp,
                                    fontWeight = FontWeight.Bold,
                                    color = MaterialTheme.colorScheme.primary
                                )
                            }
                            Spacer(modifier = Modifier.height(4.dp))
                            Text(
                                text = "Kapital Bank",
                                fontSize = if (isCompact) 14.sp else 16.sp,
                                color = MaterialTheme.colorScheme.primary
                            )
                            Spacer(modifier = Modifier.height(8.dp))
                            Text(
                                text = "Worked on building and maintaining Android applications using Kotlin. \n" +
                                        "Collaborated with a team to implement new features, fix bugs, and improve app performance\n" +
                                        "Participated in code reviews, daily standups, and gained hands-on experience in real-world app development\n" +
                                        "Integrated APIs, managed data with ViewModel and LiveData/StateFlow, and followed MVI architecture",
                                fontSize = if (isCompact) 14.sp else 16.sp,
                                color = MaterialTheme.colorScheme.primary
                            )
                            Spacer(modifier = Modifier.height(24.dp))
                            Text(
                                text = "SKILLS",
                                fontWeight = FontWeight.Bold,
                                fontSize = if (isCompact) 16.sp else 20.sp,
                                color = MaterialTheme.colorScheme.primary
                            )
                            Spacer(modifier = Modifier.height(24.dp))
                            Text(
                                text = "Language: Kotlin\n" +
                                        "UI Frameworks: Jetpack Compose, XML Layouts\n" +
                                        "Architecture: MVVM, MVI, Clean Architecture\n" +
                                        "Dependency Injection: Hilt, Koin\n" +
                                        "Networking: Retrofit, KTOR\n" +
                                        "Asynchronous Programming: Kotlin Coroutines, Flow, LiveData\n" +
                                        "Database: Room, Firebase Firestore, MongoDB (via backend)\n" +
                                        "Authentication: Firebase Auth, JWT, Email verification\n" +
                                        "Push Notifications: Firebase Cloud Messaging (FCM)\n" +
                                        "Navigation: Jetpack Navigation Component, Deep Links, App Links\n" +
                                        "Testing: JUnit, Mockito, Turbine\n" +
                                        "Tools: Android Studio, Git, GitHub, GitLab, Postman\n" +
                                        "Backend Communication: REST APIs, WebSockets\n" +
                                        "Publishing: Google Play Console (.aab release)",
                                fontSize = if (isCompact) 14.sp else 16.sp,
                                color = MaterialTheme.colorScheme.primary
                            )
                        }
                    }
                }
                Spacer(modifier = Modifier.height(36.dp))
            }
        }

    }
}

fun downloadFile() {
    window.open("/files/zaurhasanov_cv.pdf", "_blank")
}